import React, { useState } from 'react';
import { Upload, Tooltip, message } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons';
import '../../styles/Dashboard.css';

const EditAnnualLeaveRequestContent = ({requestData, setRequestData, request}) => {

    const [filesCount, setFilesCount] = useState(0);
    const { Dragger } = Upload;

    const handleChangeDate = (e, option) => {
        let { name, value } = e.target;
        value += 'T00:00:00';
        setRequestData(prevState => ({
            ...prevState,
            [name]: value
        }));  
    }    
    
    const handleBeforeUpload = (file) => {
        const fileExtensions = [
            "PDF", "JPG", "JPEG", "BMP", "PNG"
        ];  
        const parsedName = file.name.split('.');
        const index = parsedName.length - 1;
        const extension = parsedName[index];
        if (!fileExtensions.includes(extension.toUpperCase())) {
            message.warning(`Файл с расширением .${extension} запрещён для загрузки!`);                
        return Upload.LIST_IGNORE;
        }
        if(filesCount === 3) { 
            message.warning('Достигнуто максимально допустимое количество файлов 3!');
            return Upload.LIST_IGNORE;
        }
        if(file.size / 1024 > 3072) {
        message.warning('Размер файла не должен превышать 3 Мб!');                
        return Upload.LIST_IGNORE;
        } 
        return false;
    };

    const handleUpload = async (files) => {
        let formattedFiles = [];
        
        for (const file of files) {
        const parsedName = file.name.split('.');
        const index = parsedName.length - 1;
        const extension = parsedName[index];      
        const name = parsedName.slice(0, -1).join('.');
        const fileContent = await readFileAsync(file.originFileObj);
        const base64Data = btoa(fileContent);
        const attachedFile = {
            AttachedFile: base64Data,
            Appointment: "",
            NameFile: name,
            ExtensionFile: extension
        };  
        formattedFiles.push(attachedFile);   
        }
        if(formattedFiles.length === 0) {
            if(requestData.hasOwnProperty('AttachedFiles')) requestData.AttachedFiles = [];
        } else {
        requestData.AttachedFiles = formattedFiles;
        }
    };

    // Функция для чтения содержимого файла
    const readFileAsync = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
        resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsBinaryString(file);
    });
    };

    const props = {
        name: 'file',
        multiple: true,
        beforeUpload: handleBeforeUpload,
        onChange(info) {
        const { status } = info.file;
        setFilesCount(info.fileList.length);
        if(info.fileList.length === 3) message.warning('Достигнуто максимально допустимое количество файлов 3!');
        if (status !== 'uploading') {
            handleUpload(info.fileList);
        }
        },
    };

    const formatDate = (date) => {
        const rawDate = date.split('T')[0];
        const dateParts = rawDate.split('-');
        return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
    };

    return <> 
        <h2>Изменение заявления на ежегодный трудовой отпуск {request.DocNumber} от {formatDate(request.DocDate)}</h2><hr style={{ marginBottom: '32px' }}/>
        <div className='annual-leave-request-content-period' style={{ marginBottom: '32px' }}>
            <h5 style={{ marginBottom: '8px' }}>Выберите период отпуска:</h5>
            с <input
                type="date"
                name="StartDate"
                value={requestData.StartDate ? requestData.StartDate.split('T')[0] : ''}
                onChange={(e) => handleChangeDate(e)}
                style={{ marginRight: '8px' }}
            />
            по <input
                type="date"
                name="EndDate"
                value={requestData.EndDate ? requestData.EndDate.split('T')[0] : ''}
                onChange={(e) => handleChangeDate(e)}
            />
        </div>
        <div style={{ margin: '20px 0' }}>
            <a href="/templates/Образец_заявления_на_ежегодный_оплачиваемый_отпуск.docx" download style={{ fontSize: '14px', textDecoration: 'none' }}>
                Скачать образец заявления на ежегодный оплачиваемый отпуск
            </a>
        </div>
        <h5>Вложения:</h5>
        <div className='uploadContainer' style={{ marginBottom: '30px' }}>
            <Tooltip placement="bottom" title='Допустимые расширения файлов к загрузке: "PDF", "JPG", "JPEG", "BMP", "PNG". Максимально допустимый размер одного файла: 3 Мб. Максимально допустимое количество файлов: 3' overlayStyle={{ fontSize: '12px', lineHeight: '19px' }}>
            <Dragger {...props} maxCount={10}>
                <CloudUploadOutlined style={{ fontSize: '50px' }} /><br/>
                <p >Нажмите или перетащите файл в эту область, чтобы загрузить</p>
            </Dragger>
            </Tooltip>
        </div>
    </>;
};

export default EditAnnualLeaveRequestContent;